module.exports = __webpack_public_path__ + "img/features.67d4d4cd.gif";